import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconReceiptStorno: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="receipt-storno, close, remove"><path d="M8.75 14.75H15.25M13.875 7.375L12 9.25M12 9.25L10.125 11.125M12 9.25L10.125 7.375M12 9.25L13.875 11.125M4.75 2.75H19.25V21L16.6667 19L14.3333 21.25L12 19L9.66667 21.25L7.33333 19L4.75 21V2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconReceiptStorno;
